<template>
    <ConfirmDialog></ConfirmDialog>
</template>

<script>
import ConfirmDialog from 'primevue/confirmdialog';
import { useConfirm } from "primevue/useconfirm";
import { onMounted } from 'vue';

export default {
    name: 'tw-confirm',
    components: {
        ConfirmDialog
    },
    props: {
        message: String,
        resolve: null,
        reject: null
    },
    setup(props) {
        const confirm = useConfirm();

        onMounted(() => {
            confirm.require({
                message: props.message,
                header: '确认信息',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    props.resolve()
                },
                reject: () => {
                    props.reject()
                }
            });
        })
    }
}
</script>

<style>

</style>